export const HEADER_PAGE_ACTION_CLASS_NAME = "header-page-action";
export const BUTTON_DASHBOARD = "DASHBOARD";
export const BUTTON_TRAINING_COMPETENCY = "TRAINING COMPETENCY";
